export const DEFAULT_VALUES = {
  email: ''
}

export const ERROR_MESSAGES = {
  401: 'Sua conta está bloqueada temporariamente',
  400: 'Sua conta está bloqueada temporariamente',
  DEFAULT: 'E-mail inválido'
}
